import P from "./objectWithoutPropertiesLoose.mjs";
import i from "./extends.mjs";
import * as l from "react";
import e from "./index180.mjs";
import { clsx as x } from "./clsx.mjs";
import L from "./styled.mjs";
import T from "./useThemeProps.mjs";
import v from "./ListContext.mjs";
import { getListUtilityClass as y } from "./listClasses.mjs";
import { jsx as j, jsxs as N } from "react/jsx-runtime";
import R from "./composeClasses.mjs";
const C = ["children", "className", "component", "dense", "disablePadding", "subheader"], O = (s) => {
  const {
    classes: o,
    disablePadding: t,
    dense: r,
    subheader: n
  } = s;
  return R({
    root: ["root", !t && "padding", r && "dense", n && "subheader"]
  }, y, o);
}, _ = L("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (s, o) => {
    const {
      ownerState: t
    } = s;
    return [o.root, !t.disablePadding && o.padding, t.dense && o.dense, t.subheader && o.subheader];
  }
})(({
  ownerState: s
}) => i({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !s.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, s.subheader && {
  paddingTop: 0
})), m = /* @__PURE__ */ l.forwardRef(function(o, t) {
  const r = T({
    props: o,
    name: "MuiList"
  }), {
    children: n,
    className: a,
    component: c = "ul",
    dense: d = !1,
    disablePadding: u = !1,
    subheader: f
  } = r, b = P(r, C), h = l.useMemo(() => ({
    dense: d
  }), [d]), p = i({}, r, {
    component: c,
    dense: d,
    disablePadding: u
  }), g = O(p);
  return /* @__PURE__ */ j(v.Provider, {
    value: h,
    children: /* @__PURE__ */ N(_, i({
      as: c,
      className: x(g.root, a),
      ref: t,
      ownerState: p
    }, b, {
      children: [f, n]
    }))
  });
});
process.env.NODE_ENV !== "production" && (m.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: e.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: e.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: e.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
});
const k = m;
export {
  k as default
};
//# sourceMappingURL=List.mjs.map
